import { render } from "./NewsItem.vue?vue&type=template&id=4ac13482"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QIcon});
